/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePrescriptionOrderRequestDto
 */
export interface CreatePrescriptionOrderRequestDto {
    /**
     * Shipping address (street address)
     * @type {string}
     * @memberof CreatePrescriptionOrderRequestDto
     */
    shippingAddress: string;
    /**
     * City for shipping
     * @type {string}
     * @memberof CreatePrescriptionOrderRequestDto
     */
    city: string;
    /**
     * State for shipping (2-letter code)
     * @type {string}
     * @memberof CreatePrescriptionOrderRequestDto
     */
    state: string;
    /**
     * ZIP code for shipping
     * @type {string}
     * @memberof CreatePrescriptionOrderRequestDto
     */
    zip: string;
    /**
     * Country for shipping
     * @type {string}
     * @memberof CreatePrescriptionOrderRequestDto
     */
    country: string;
}

/**
 * Check if a given object implements the CreatePrescriptionOrderRequestDto interface.
 */
export function instanceOfCreatePrescriptionOrderRequestDto(value: object): value is CreatePrescriptionOrderRequestDto {
    if (!('shippingAddress' in value) || value['shippingAddress'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function CreatePrescriptionOrderRequestDtoFromJSON(json: any): CreatePrescriptionOrderRequestDto {
    return CreatePrescriptionOrderRequestDtoFromJSONTyped(json, false);
}

export function CreatePrescriptionOrderRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePrescriptionOrderRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'shippingAddress': json['shippingAddress'],
        'city': json['city'],
        'state': json['state'],
        'zip': json['zip'],
        'country': json['country'],
    };
}

export function CreatePrescriptionOrderRequestDtoToJSON(json: any): CreatePrescriptionOrderRequestDto {
    return CreatePrescriptionOrderRequestDtoToJSONTyped(json, false);
}

export function CreatePrescriptionOrderRequestDtoToJSONTyped(value?: CreatePrescriptionOrderRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shippingAddress': value['shippingAddress'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'country': value['country'],
    };
}

